/**
 * @description
 * @param key 
 */
const keyTree = (key?: any): any => {
    const d: any = {
        id: {
            value: "id", // 前后端数据key
            text: "id", // 前端页面显示文字
            tip: "", // 前端页面提示文字,有的话页面会有个小气泡
            valType: 'str',//查看页面分类
            type: '字符串',//编辑页面分类
        },
        field_oid: {
            value: "field_oid",
            text: "编码",
            tip: "",
            valType: 'str',
            type: '字符串',
        },
        type: {
            value: "type",
            text: "类型",
            tip: "",
            valType: 'str',
            required: true,
            type: '类型',
        },
        h1_title: {
            value: "h1_title",
            text: "一级标题",
            tip: "等同于主标题，会居中显示",
            valType: 'str',
            type: '字符串',
        },
        h2_title: {
            value: "h2_title",
            text: "二级标题",
            tip: "等同于段落标题，字号会比标题字号大",
            valType: 'str',
            type: '字符串',
        },
        title: {
            value: "title",
            text: "标题",
            tip: "",
            valType: 'str',
            type: '字符串',
        },
        sub_title: {
            value: "sub_title",
            text: "补充标题",
            tip: "介于标题和内容之间，内容可配置当前所有控件",
            valType: 'arr',
            type: '二级嵌套',
        },
        inline: {
            value: "inline",
            text: "是否换行",
            tip: "选择'否'时标题和内容是连续的，不换行",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: false
                },
                {
                    label: "否",
                    value: true
                }
            ]
        },
        is_required: {
            value: "is_required",
            text: "是否必填",
            tip: "选择'是'时,题目未填不能保存",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                }
            ]
        },
        hide: {
            value: "hide",
            text: "是否隐藏",
            tip: "选择'是'时,初次进入页面题目不会显示，可通过逻辑题目控制显示",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                }
            ]
        },
        name: {
            value: "name",
            text: "前置文字",
            tip: "值前面的解释文字",
            valType: 'str',
            type: '字符串',
        },
        value: {
            value: "value",
            text: "文本",
            tip: "静态文本",
            valType: 'str',
            type: '文本域',
        },
        unit: {
            value: "unit",
            text: "后置文字",
            tip: "值后面的补充文字，比如单位",
            valType: 'str',
            type: '字符串',
        },
        border_line: {
            value: "border_line",
            text: "下划线边框",
            tip: "选择'是'时,输入框为下划线边框",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                }
            ]
        },
        size: {
            value: "size",
            text: "输入框长度",
            tip: "",
            valType: 'str',
            type: "下拉单选",
            option: [
                {
                    label: "100%",
                    value: "100%"
                },
                {
                    label: "50%",
                    value: "middle"
                },
                {
                    label: "200px",
                    value: "min"
                },
                {
                    label: "100px",
                    value: "mini"
                },
            ]
        },
        extra: {
            value: "extra",
            text: "二级内容",
            tip: "扩展的二级组件，配置方式跟二级相同",
            valType: 'arr',
            type: '二级嵌套'
        },
        options: {
            value: "options",
            text: "选项",
            tip: "",
            valType: 'arr',
            type: '选项',
            required: true,
        },
        control: {
            value: "control",
            text: "逻辑控制",
            tip: "选择选项选中时需要控制的题目，没有逻辑控制的不需要配置",
            valType: 'control',
            type: '逻辑控制',
        },
        format: {
            value: "format",
            text: "时间格式",
            tip: "",
            valType: 'str',
            type: "下拉单选",
            option: [
                {
                    label: "yyyy-MM-dd HH:mm:ss",
                    value: "yyyy-MM-dd HH:mm:ss"
                },
                {
                    label: "yyyy-MM-dd HH:mm",
                    value: "yyyy-MM-dd HH:mm"
                },
                {
                    label: "yyyy-MM-dd HH",
                    value: "yyyy-MM-dd HH"
                },
                {
                    label: "yyyy-MM-dd",
                    value: "yyyy-MM-dd"
                },
                {
                    label: "yyyy-MM",
                    value: "yyyy-MM"
                },
                {
                    label: "yyyy",
                    value: "yyyy"
                },
            ]
        },
        search: {
            value: "search",
            text: "搜索类型",
            tip: "搜索的数据类型，例如“中医疾病”",
            valType: 'str',
            required: true,
            type: '字符串',
        },
        url: {
            value: "url",
            text: "地址",
            tip: "可以直接在浏览器打开的地址",
            valType: 'str',
            required: true,
            type: '字符串',
        },
        lianjie: {
            value: "url",
            text: "地址",
            tip: "可以直接在浏览器打开的地址",
            valType: 'arr',
            type: 'lianjie',
        },
        width: {
            value: "width",
            text: "宽度",
            tip: "图片在页面显示的宽度",
            valType: 'str',
            required: true,
            type: '数字',
            min: 1
        },
        multiple: {
            value: "multiple",
            text: "支持多选",
            tip: "选择'是'时,上传时可一次选择多个s",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                }
            ]
        },
        setting: {
            value: "setting",
            text: "设置",
            tip: "",
            valType: 'setting',
            type: '设置',
        },
        numSetting: {
            value: "setting",
            text: "设置",
            tip: "",
            valType: 'setting',
            type: '设置',
        },
        yatongdianSetting: {
            value: "setting",
            text: "压痛点类型",
            tip: "",
            valType: 'str',
            type: '下拉单选',
            required: true,
            option: [
                {
                    label: "正面压痛点左侧",
                    value: "正面压痛点左侧"
                },
                {
                    label: "正面压痛点右侧",
                    value: "正面压痛点右侧"
                },
                {
                    label: "侧面压痛点左侧",
                    value: "侧面压痛点左侧"
                },
                {
                    label: "侧面压痛点右侧",
                    value: "侧面压痛点右侧"
                },
                {
                    label: "正面压痛点左侧",
                    value: "正面压痛点左侧"
                },
                {
                    label: "正面压痛点右侧",
                    value: "正面压痛点右侧"
                },
                {
                    label: "膝关节压痛点左膝",
                    value: "膝关节压痛点左膝"
                },
                {
                    label: "膝关节压痛点右膝",
                    value: "膝关节压痛点右膝"
                },
                {
                    label: "腰椎病压痛点左侧",
                    value: "腰椎病压痛点左侧"
                },
                {
                    label: "腰椎病压痛点右侧",
                    value: "腰椎病压痛点右侧"
                },
            ]
        },
        uploadNum: {
            value: "setting",
            text: "最多上传个数",
            tip: "",
            valType: 'str',
            type: '文件个数',
            min: 1
        },
        basic: {
            value: "basic",
            text: "基础格式",
            tip: "数组的内容，内容为当前的",
            valType: 'arr',
            type: '二级嵌套'
        },
        jianyanxiang: {
            value: "children",
            text: "检验项",
            tip: "",
            valType: 'jianyanxiang',
            type: '检验项'
        },
        text_align: {
            value: "text_align",
            text: "对齐方式",
            tip: "表格内容的对齐方式",
            valType: 'str',
            type: "下拉单选",
            option: [
                {
                    label: "左对齐",
                    value: "left"
                },
                {
                    label: "居中对齐",
                    value: "center"
                },
                {
                    label: "右对齐",
                    value: "right"
                }

            ]
        },
        border: {
            value: "border",
            text: "是否有分割线",
            tip: "选择'是'时,表格会有分割线",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                }
            ]
        },
        has_header: {
            value: "has_header",
            text: "是否有表头",
            tip: "选择'是'时,表格第一行会是表头，表头文字会加粗",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                }
            ]
        },
        disabled_futureTime: {
            value: "disabled_future_time",
            text: "禁用未来时间",
            tip: "选择'是'时,未来时间不能选",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                }
            ]
        },
        table: {
            value: "value",
            text: "表格内容",
            tip: "",
            valType: 'table',
            type: '表格'
        },
        showSort: {
            value: "showSort",
            text: "是否显示序号",
            tip: "选择'是'时,动态数组每一项前面会出现标题加序号",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                }
            ]
        },
        hideDetail: {
            value: "hideDetail",
            text: "隐藏详细地址",
            tip: "选择'是'时, 地址控件后面没有详情输入框",
            valType: 'boolean',
            type: "下拉单选",
            option: [
                {
                    label: "是",
                    value: true
                },
                {
                    label: "否",
                    value: false
                }
            ]
        },
    };
    if (key) {
        return d[key]
    } else {
        return d
    }

}
const templateTree = (): any => {
    const d: any = [
        {
            label: '主标题',
            children: ["id", "field_oid", "type", "title", "hide"]
        },
        {
            label: '段落标题',
            children: ["id", "field_oid", "type", "title", "hide"]
        },
        {
            label: '文本',
            children: ["id", "field_oid", "type", "title", "value", "is_required", "hide", "inline", "name", "unit", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '字符串',
            children: ["id", "field_oid", "type", "title", "is_required", "hide", "inline", "border_line", "size", "name", "unit", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '文本域',
            children: ["id", "field_oid", "type", "title", "is_required", "hide", "inline", "border_line", "size", "name", "unit", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '数字',
            children: ["id", "field_oid", "type", "title", "numSetting", "is_required", "hide", "inline", "border_line", "size", "name", "unit", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '固定单位数字',
            children: ["id", "field_oid", "type", "title", "numSetting", "is_required", "hide", "inline", "border_line", "size", "name", "unit", "h1_title", "h2_title", "sub_title", "extra"]
        },
        {
            label: '单个时间',
            children: ["id", "field_oid", "type", "title", "is_required", "hide", "inline", "format", "disabled_futureTime", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '图片',
            children: ["id", "field_oid", "type", "title", "url", "width", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '链接',
            children: ["id", "field_oid", "type", "title", "lianjie", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '单选',
            children: ["id", "field_oid", "type", "title", "options", "control", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '下拉单选',
            children: ["id", "field_oid", "type", "title", "options", "control", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '计分单选',
            children: ["id", "field_oid", "type", "title", "options", "control", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: 'sf36计分单选',
            children: ["id", "field_oid", "type", "title", "options", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '单选补充文字',
            children: ["id", "field_oid", "type", "title", "options", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '多选',
            children: ["id", "field_oid", "type", "title", "options", "control", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '搜索多选',
            children: ["id", "field_oid", "type", "title", "search", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '目录式多选',
            children: ["id", "field_oid", "type", "title", "search", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '多选补充文字',
            children: ["id", "field_oid", "type", "title", "options", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '家庭住址',
            children: ["id", "field_oid", "type", "title", "is_required", "hide", "inline", "hideDetail", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '文件',
            children: ["id", "field_oid", "type", "title", "multiple", "uploadNum", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '视频',
            children: ["id", "field_oid", "type", "title", "multiple", "uploadNum", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '计分条',
            children: ["id", "field_oid", "type", "title", "multiple", "setting", "is_required", "hide", "inline", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '中药饮片信息',
            children: ["id", "field_oid", "type", "title", "hide", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '其它用药信息',
            children: ["id", "field_oid", "type", "title", "hide", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '压痛点',
            children: ["id", "field_oid", "type", "title", "hide", "is_required", "yatongdianSetting", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '动态数组',
            children: ["id", "field_oid", "type", "title", "hide", "showSort", "basic", "is_required", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '检验组',
            children: ["id", "field_oid", "type", "title", "hide", "jianyanxiang", "h1_title", "h2_title", "sub_title"]
        },
        {
            label: '表格',
            children: ["id", "field_oid", "type", "title", "is_required", "hide", "text_align", "border", "has_header", "table", "h1_title", "h2_title", "sub_title"]
        },
    ]
    return d
}
const allKey = (): any => {
    let d: any = [];
    for (const key in keyTree()) {
        d.push(key);
    }
    return d;
}

/**
 * @description 题目类型数组
 */
const types = (): any => {
    let d: any = [];
    templateTree().forEach((ele: any) => {
        d.push(ele.label);
    });
    return d;
}

/**
 * @description 题目类型有的属性
 * @param type 类型 主标题，字符串，单选，多选等
 */
const typeKey = (type?: any): any => {
    let d: any = {};
    templateTree().forEach((ele: any) => {
        d[ele.label] = ele.children
    });
    if (type) {
        return d[type]
    } else {
        return d
    }
}

/**
 * @description 是否有此属性
 * @param type 类型，单选，多选等
 * @param key 字段，title，name，unit等
 */
const ifExitKey = (type: any, key: any): any => {
    if (!type) {
        return;
    }
    const keyArr: any = typeKey(type);
    if (keyArr && keyArr.length > 0 && keyArr.indexOf(key) !== -1) {
        return true;
    } else {
        return false;
    }
}
export {
    keyTree, allKey, types, typeKey, ifExitKey
}